import { render } from "./RxInvestigations.vue?vue&type=template&id=5f39a7a8&scoped=true"
import script from "./RxInvestigations.vue?vue&type=script&lang=js"
export * from "./RxInvestigations.vue?vue&type=script&lang=js"

import "./RxInvestigations.vue?vue&type=style&index=0&id=5f39a7a8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f39a7a8"]])

export default __exports__